import { Component, inject, input, output, ViewChild } from '@angular/core';
import { TrackData } from '@shared/interfacres/track';
import { PlayerSourceService } from '@shared/components/player-bar/player-source.service';
import { MatSort, MatSortHeader } from '@angular/material/sort';
import {
  MatCell,
  MatCellDef, MatColumnDef, MatHeaderCell, MatHeaderCellDef,
  MatHeaderRow,
  MatHeaderRowDef,
  MatRow,
  MatRowDef,
  MatTable
} from '@angular/material/table';
import { MatProgressBar } from '@angular/material/progress-bar';
import { DatePipe, NgClass } from '@angular/common';
import { MatIcon } from '@angular/material/icon';
import { FormsModule } from '@angular/forms';
import { CustomPaginator, PAGINATOR_LABEL } from '@shared/components/custom-paginator/custom-paginator';
import { LibraryStore } from '@data-access/user/stores/library.store';


@Component({
  selector: 'app-tracks-list',
  imports: [
    MatRowDef,
    MatRow,
    MatHeaderRow,
    MatHeaderRowDef,
    MatCell,
    MatCellDef,
    MatHeaderCell,
    MatSortHeader,
    MatHeaderCellDef,
    MatColumnDef,
    MatProgressBar,
    MatTable,
    MatSort,
    DatePipe,
    MatIcon,
    NgClass,
    FormsModule,
    CustomPaginator,
  ],
  providers: [{provide: PAGINATOR_LABEL, useValue: 'Tracks per page: '}],
  templateUrl: './tracks-list.html',
  styleUrl: './tracks-list.scss'
})
export class TracksList {
  displayedColumns: string[] = ['id', 'title', 'artists', 'genre', 'bpm', 'releaseDate', 'downloads', 'actions'];
  dataSource = input<TrackData[]>([]);
  tracksTotal = input<number>(0);
  isLoading = input<boolean>(false);
  showPaginator = input<boolean>(true);

  pageIndex = input(0);

  pageChanged = output<{pageIndex: number; pageSize: number}>();
  sortChanged = output<{active: string; direction: string}>();

  downloadClicked = output<{id: number; title: string}>();

  tracksStore = inject(LibraryStore);
  playerSource = inject(PlayerSourceService);

  @ViewChild(MatSort) sort!: MatSort;

  @ViewChild('table', { static: true }) table: MatTable<TrackData> | undefined;


  play(index: number, track: TrackData) {
    this.playerSource.init(false);
    if (this.playerSource.currentTrack() && this.playerSource.currentTrack()?.id === track.id) {
      // track pressed again
      if (this.playerSource.isPlaying()) {
        this.playerSource.pause();
      } else {
        this.playerSource.play();
      }

      return;
    }
    this.playerSource.setTracksList(this.dataSource(), index, true);
  }

  changePage(page: {pageIndex: number; pageSize: number}) {
    this.pageChanged.emit(page);
  }

  sortChange(event: {active: string; direction: string}) {
    this.sortChanged.emit(event);
  }
  async download(track: TrackData) {

    if (track.downloadsCount &&  track.downloadsCount > 2) {
      return;
    }
    if (this.tracksStore.downloadsLeft() < 1) {
      return;
    }
    this.downloadClicked.emit({id: track.id, title: track.title});

  }

}
